import { createStore } from 'vuex'
import moduleUser from './moduleUser/index'
import moduleB from './moduleB/index'
console.log(moduleUser)
export default createStore({
    modules: {
        moduleUser: moduleUser,
        moduleB: moduleB
    }
})